module.exports = __webpack_public_path__ + "static/media/perc2.e1fcd512.ogg";